import { _, helpers, React, ts, ui } from '_core';

import { useMemo } from 'react';

import { transform } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, file, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.HeatMapData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: file,
        },
      });

      if (response) {
        setData(response.data as ts.types.widgets.HeatMapData);
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  const formattedData = useMemo(() => {
    if (_.isNil(data)) return [];
    return transform(data);
  }, [data]);

  return (
    <ui.HeatmapChart
      id={id}
      data={formattedData as ts.types.widgets.HeatMapData}
      xAxisField="factor_x"
      yAxisField="factor_y"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      fullScreen={fullScreen}
      readOnly={readOnly}
      rotation={45}
    />
  );
};

export default Chart;
